import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';
import { API_BASE } from '../lib/utils';
import { GraduationCap } from 'lucide-react';

const CounsellorLogin = () => {
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '', speciality: 'Career Guidance' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const endpoint = isRegister ? 'counsellor/register' : 'counsellor/login';
      const payload = isRegister ? form : { email: form.email, password: form.password };
      const res = await axios.post(`${API_BASE}/${endpoint}`, payload);
      localStorage.setItem('counsellor_token', res.data.token);
      localStorage.setItem('counsellor_user', JSON.stringify(res.data.user));
      toast.success(isRegister ? 'Account created!' : 'Logged in!');
      navigate('/counsellor/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <GraduationCap className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-semibold text-[#1d1d1f] mb-1">
            {isRegister ? 'Counsellor Registration' : 'Counsellor Login'}
          </h1>
          <p className="text-base text-[#86868b]">ApprenticeshipMatch Career Guidance Portal</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#f5f5f7] rounded-3xl p-8 space-y-4">
          {isRegister && (
            <>
              <Input
                placeholder="Full Name"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                className="h-12 rounded-xl border-[#d2d2d7] bg-white"
                required
                data-testid="counsellor-name-input"
              />
              <Input
                placeholder="Speciality (e.g. Career Guidance)"
                value={form.speciality}
                onChange={e => setForm({ ...form, speciality: e.target.value })}
                className="h-12 rounded-xl border-[#d2d2d7] bg-white"
                data-testid="counsellor-speciality-input"
              />
            </>
          )}
          <Input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
            className="h-12 rounded-xl border-[#d2d2d7] bg-white"
            required
            data-testid="counsellor-email-input"
          />
          <Input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            className="h-12 rounded-xl border-[#d2d2d7] bg-white"
            required
            data-testid="counsellor-password-input"
          />
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl h-12"
            data-testid="counsellor-submit-btn"
          >
            {loading ? 'Please wait...' : isRegister ? 'Create Account' : 'Sign In'}
          </Button>
          <p className="text-center text-sm text-[#86868b]">
            {isRegister ? 'Already have an account?' : "Don't have an account?"}{' '}
            <button type="button" onClick={() => setIsRegister(!isRegister)} className="text-emerald-600 font-medium hover:underline" data-testid="toggle-auth-mode">
              {isRegister ? 'Sign In' : 'Register'}
            </button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default CounsellorLogin;
